import { useMemo } from 'react';

import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks';
import { useCurrentOrganisationStore } from '@/modules/core/store';

import { useGetRenewalsQuery } from '../queries';

import { useFormattedRenewals } from './useFormattedRenewals';

export const useGetRenewals = () => {
  const { organizationId } = useCurrentOrganisationStore();
  const { observingOrganization: { type } } = useCurrentOrganization();
  const isEmployerObserving = useMemo(() => type === OrganizationTypes.company, [type]);

  const { data, isSuccess, isLoading } = useGetRenewalsQuery(organizationId, isEmployerObserving);
  const formattedRenewals = useFormattedRenewals(data);

  return {
    renewals: formattedRenewals,
    isLoading,
    isSuccess,
  };
};

export default useGetRenewals;
